<template>
    <loading 
        v-model:active="isLoading" 
        :loader="'dots'">
        <template v-slot:default>
            <Spinner></Spinner>
        </template>
    </loading>
    <Toast position="top-center"/>
    <router-view />
</template>

<script setup>
    import { computed, onMounted } from 'vue'
    import store from '@/store'

    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/css/index.css'
    import Spinner from '@/components/Spinner'

    const isLoading = computed(() => store.state.isLoading)

    onMounted(() => {
        // Evita el warning de accesibilidad causado por PrimeVue:
        // "Blocked aria-hidden on an element because its descendant retained focus."
        // Si un elemento con aria-hidden recibe foco, lo desenfocamos automáticamente.
        document.addEventListener('focusin', (e) => {
            const el = e.target
            if (
                el instanceof HTMLElement &&
                el.getAttribute('aria-hidden') === 'true'
            ) {
                el.blur()
            }
        })
    })
</script>